// KI-Kennzeichnung (Art. 50 KI-VO), 13.10.2026: für Bilder, die erst im Browser entstehen (Schnellansicht, Suchvorschläge,
// Sticky nach Variantenwechsel) und für Bilder in Produktbeschreibungen (Shopdaten, nicht geändert).
// Regel wie snippets/jars-ki-marke.liquid; die Liste steht in <script id="jars-ki-liste"> (snippets/jars-kopf.liquid).
(function () {
  var liste = {};
  try { liste = JSON.parse(document.getElementById('jars-ki-liste').textContent); } catch (e) {}

  function art(src) {
    var datei = String(src || '').split('?')[0].split('/').pop();
    if ((liste.bearbeitet || []).indexOf(datei.slice(0, 18)) > -1 || (liste.bearbeitetDatei || []).indexOf(datei) > -1) return 'bearbeitet';
    return datei.slice(0, 3) === 'hf_' ? 'erstellt' : '';
  }

  // Setzt die Marke neben das Bild oder entfernt sie (Bildwechsel auf ein echtes Foto). opt: box, lage, klein
  function marke(img, opt) {
    opt = opt || {};
    var box = opt.box || (img && img.parentNode);
    if (!box) return;
    var alt = box.querySelector(':scope > [data-jars-ki]');
    if (alt) alt.remove();
    var a = art(img.getAttribute('src'));
    var texte = { erstellt: 'Mit KI erstellt', bearbeitet: 'KI bearbeitet' };
    img.alt = (img.alt || '').replace(/ \((Mit KI erstellt|KI bearbeitet)\)$/, '');
    if (!a) return;
    var s = document.createElement('span');
    s.className = 'jars-ki-marke jars-ki-marke--' + (opt.lage || 'unten-rechts') + (opt.klein ? ' jars-ki-marke--klein' : '');
    s.setAttribute('data-jars-ki', a);
    if (opt.klein) s.title = texte[a];
    s.textContent = opt.klein ? (a === 'erstellt' ? 'KI erstellt' : 'KI bearb.') : texte[a];
    if (getComputedStyle(box).position === 'static') box.classList.add('jars-ki-rahmen');
    box.appendChild(s);
    img.alt = (img.alt + ' (' + texte[a] + ')').trim();
  }

  window.jarsKiArt = art;
  window.jarsKiMarke = marke;
  window.jarsKiBeschreibung = beschreibungen;

  // ponytail: nur Beschreibungs-Behälter, kein MutationObserver; dynamische Stellen rufen jarsKiMarke selbst auf
  function beschreibungen(root) {
    (root && root.querySelectorAll ? root : document).querySelectorAll('.jars-pd img, .rte img' + (root && root.querySelectorAll ? ', img' : '')).forEach(function (img) {
      if (!art(img.getAttribute('src'))) return;
      var w = img.parentNode;
      if (!w.classList.contains('jars-ki-wrap')) {
        w = document.createElement('span');
        w.className = 'jars-ki-wrap';
        img.parentNode.insertBefore(w, img);
        w.appendChild(img);
      }
      marke(img, { box: w });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { beschreibungen(); });
  else beschreibungen();
})();
